import { useTranslation } from "react-i18next";
import { LangLink as Link } from "./LangLink";

export function NotFound() {
  const { t } = useTranslation("common");

  return (
    <div className="bg-[#050505] min-h-screen flex items-center justify-center font-sans">
      <div className="flex flex-col items-center justify-center text-center px-4">
        <h1 className="display text-6xl md:text-8xl text-white mb-6">404</h1>
        <h2 className="text-2xl md:text-3xl text-white/80 mb-8 uppercase tracking-wider">
          {t("notFound.title", "Page Not Found")}
        </h2>
        <p className="text-lg text-white/60 max-w-md mb-10">
          {t("notFound.desc", "The page you are looking for does not exist or has been moved.")}
        </p>
        <Link to="/" className="btn-pill">
          {t("notFound.back", "Back to Home")}
        </Link>
      </div>
    </div>
  );
}
